import { BookMinusIcon } from 'components/Icons';

import { registerTaskOption } from '../options';

import { ExcludedIdsModal } from './IdsModal';

export default registerTaskOption({
  Icon: BookMinusIcon,

  getLabel: (t) => t('excluded-ids'),

  modal: 'EXCLUDED_IDS',
  overlay: ExcludedIdsModal,

  shortcutKey: 'E',

  useOption: ({ task, openModal }) => ({
    action: () => openModal('EXCLUDED_IDS'),
    isEnabled: !!task.requireExcludedOWIds,
  }),
});
